<igx-grid #grid [data]="this.users | sorting" [height]="'500px'" [primaryKey]="'id'" rowSelection="single"
    [hideRowSelectors]="true" igxGridState [moving]="true" (columnMoving)="columnMoving($event)">
    <igx-grid-toolbar>
        <igx-grid-toolbar-actions>
            <button igxButton igxRipple (click)="openUserDialog(dialog)">Добави потребител</button>
        </igx-grid-toolbar-actions>
    </igx-grid-toolbar>
    <igx-column [pinned]="true" [resizable]="false">
        <ng-template igxCell let-cell="cell">
            <button title="Обнови парола" igxIconButton="flat" (click)="openUpdatePasswordDialog(updatePasswordDialog, cell)">
                <igx-icon>lock_reset</igx-icon>
            </button>
        </ng-template>
    </igx-column>
    <igx-column width="50px" [pinned]="true" [resizable]="false">
        <ng-template igxCell let-cell="cell">
            <button title="Редактирай" igxIconButton="flat" (click)="openUserDialog(dialog, cell)">
                <igx-icon>edit</igx-icon>
            </button>
        </ng-template>
    </igx-column>
    <igx-column field="username" header="Потребител" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="firstName" header="Име" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="lastName" header="Фамилия" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="email" header="e-mail" [sortable]="true" [disablePinning]="true" [resizable]="true"></igx-column>
    <igx-column field="role" header="Роля" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            {{ parseRole(cell) }}
        </ng-template>
    </igx-column>
    <igx-column field="isActive" header="Активен" [dataType]="'boolean'" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
</igx-grid>
<igx-dialog #dialog>
    <igx-dialog-title>{{ dialogText }} профил</igx-dialog-title>
    <form [formGroup]="userForm" (ngSubmit)="userSubmit(dialog)">
        <igx-input-group type="border">
            <label igxLabel>Потребителско име</label>
            <input igxInput [igxTextSelection]="true" name="username" formControlName="username" />
        </igx-input-group>
        <igx-input-group type="border">
            <label igxLabel>Име</label>
            <input igxInput [igxTextSelection]="true" name="firstName" formControlName="firstName" />
        </igx-input-group>
        <igx-input-group type="border">
            <label igxLabel>Фамилия</label>
            <input igxInput [igxTextSelection]="true" name="lastName" formControlName="lastName" />
        </igx-input-group>
        <igx-input-group type="border">
            <label igxLabel>e-mail</label>
            <input igxInput [igxTextSelection]="true" name="email" formControlName="email" />
        </igx-input-group>
        <igx-select formControlName="role">
            <label igxLabel>Роля</label>
            <igx-select-item *ngFor="let role of roles" [value]="role.value">{{ role.name }}</igx-select-item>
        </igx-select>
        <igx-checkbox name="isActive" formControlName="isActive" type="border">Активен</igx-checkbox>
        <igx-dialog-actions>
            <button igxButton="outlined" type="button" (click)="closeDialog(dialog)">ОТКАЖИ</button>
            <button igxButton="contained" type="submit">{{ dialogText }}</button>
        </igx-dialog-actions>
    </form>
</igx-dialog>
<igx-dialog #updatePasswordDialog>
    <igx-dialog-title>Изпрати нова парола на {{ updatePasswordUser?.username }}</igx-dialog-title>
    <div class="flex">
        <button igxButton="outlined" (click)="updatePasswordDialog.close()">Откажи</button>
        <button igxButton="contained" (click)="updatePassword(updatePasswordDialog)">Изпрати</button>
    </div>
</igx-dialog>
